//
//
//
//
//

export default {
    data(){
        return{
            imgsrc:this.$router.history.current.query.imgsrc,
            imgHeight:0,
            top:0,
        }
    },
    mounted(){
        let img= document.getElementsByTagName('img')[0];
        let self = this;
        img.onload = function(){
            self.top = (document.getElementById('view_01').clientHeight - this.height ) / 2;
        }
    },
    methods:{
        goback(){
            this.$router.go(-1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/momentsComponents/preview.vue